import { CampaignType } from "@adlywise/shared";
import Card from "@/components/common/Card";
import IconPicker from "@/components/common/IconPicker";
import FlightDateRange from "@/components/common/FlightDateRange";

const CAMPAIGN_TYPE_OPTIONS = [
  { value: CampaignType.Standard, label: "Standard" },
  { value: CampaignType.Transit, label: "Transit" },
];

export default function Step1Basics({ form, onFieldChange }) {
  return (
    <Card className="builder-form flex flex-col gap-5">
      <div className="form-group-modal">
        <label htmlFor="campaign-name">Campaign name</label>
        <div className="flex items-center gap-3">
          <IconPicker
            iconOnly
            value={form.icon ?? ""}
            onChange={(next) => onFieldChange("icon", next || null)}
          />
          <input
            id="campaign-name"
            className="flex-1"
            value={form.name}
            onChange={(event) => onFieldChange("name", event.target.value)}
            placeholder="e.g. Spring Awareness Push"
            required
          />
        </div>
      </div>

      <div className="form-group-modal">
        <label htmlFor="campaign-description">Description</label>
        <textarea
          id="campaign-description"
          value={form.description}
          onChange={(event) => onFieldChange("description", event.target.value)}
          placeholder="Short description, goals, or context for the campaign…"
          rows={3}
        />
      </div>

      <div className="form-group-modal max-w-md">
        <label>Campaign type</label>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "0.75rem",
            marginTop: "0.25rem",
          }}
        >
          {CAMPAIGN_TYPE_OPTIONS.map((opt) => (
            <label
              key={opt.value}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.4rem",
                cursor: "pointer",
              }}
            >
              <input
                type="radio"
                name="campaign-type"
                value={opt.value}
                checked={form.type === opt.value}
                onChange={() => onFieldChange("type", opt.value)}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
        {form.type === CampaignType.Transit && (
          <p className="form-help-text">
            Transit campaigns proxy bid requests through RTB publishers with
            allowTransit enabled.
          </p>
        )}
      </div>

      <div className="form-group-modal max-w-md">
        <label>Flight dates</label>
        <FlightDateRange
          startDate={form.startDate ?? ""}
          endDate={form.endDate ?? ""}
          onChange={(start, end) => {
            onFieldChange("startDate", start);
            onFieldChange("endDate", end);
          }}
        />
      </div>
    </Card>
  );
}
